import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'reactstrap';

function DashboardMetricCard(props) {
  const {
    accent,
    eyebrow,
    title,
    icon,
    percentage,
    summary,
    details,
  } = props;

  return (
    <div className="dashboard-metric" style={{ '--dashboard-accent': accent }}>
      <div className="dashboard-metric__header">
        <div>
          <span className="dashboard-metric__eyebrow">{eyebrow}</span>
          <h3 className="dashboard-metric__title">{title}</h3>
        </div>
        <div className="dashboard-metric__icon">
          <i className={icon} />
        </div>
      </div>

      <div className="dashboard-metric__score">
        <span className="dashboard-metric__score-value">
          {percentage}
          %
        </span>
        <span className="dashboard-metric__summary">{summary}</span>
      </div>

      <Progress
        className="dashboard-metric__progress"
        value={percentage}
      />

      <div className="dashboard-metric__details">
        {details.map((detail) => (
          <div className="dashboard-metric__detail" key={detail.label}>
            <span>{detail.label}</span>
            <strong>{detail.value}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}

DashboardMetricCard.propTypes = {
  accent: PropTypes.string.isRequired,
  eyebrow: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  summary: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
};

export default DashboardMetricCard;
